import React, { useState } from "react";
import { Button, Modal } from "@/components/Common";
import { useTce } from "@/hooks/tces";
import { Container, Assinante, ModalContent, ModalFooter } from "./styles";
import { useSelector } from "react-redux";
import toastify from "@/services/toastify";

export default function AssinantesEscola({ tce }) {
  const { assinanteReenviarEmail, removeAssinante, loading } = useTce();
  const { data: user } = useSelector(state => state.auth);
  const [assinanteToRemove, setAssinanteToRemove] = useState(null);

  function renderAssinantes() {
    const { assinantes_escola } = tce;

    if (assinantes_escola.length === 0) {
      return <p>Adicione assinantes clicando em "Adicionar outro assinante".</p>;
    }

    return assinantes_escola.map(assinante_escola => {

      let status = "Aguardando";
      if (assinante_escola.data_assinatura != null) status = "Aprovado";
      if (assinante_escola.deleted_at != null) status = "Reprovado";

      const { assinante } = assinante_escola

      return (
        <Assinante status={status}>
          <div className="coluna coluna-nome">
            <h4>{assinante.nome} {assinante.sobrenome}</h4>
            <p>{assinante.email}</p>
          </div>
          <div className="coluna coluna-status">
            <h4>Status</h4>
            <p>{status}</p>
          </div>
          <div className="coluna coluna-actions">
            <Button
              variant="cyan"
              disabled={status !== "Aguardando"}
              loading={loading || undefined}
              onClick={() => {
                assinanteReenviarEmail(tce.id, assinante_escola);
              }}
            >
              Reenviar
            </Button>
            <Button
              variant="magenta"
              disabled={status !== "Aguardando"}
              style={{ marginLeft: 10 }}
              loading={loading || undefined}
              onClick={() => setAssinanteToRemove(assinante_escola)}
            >
              Remover
            </Button>
            {user.rootProfile && (
              <Button
                variant="cyan"
                disabled={status !== "Aguardando"}
                style={{ marginLeft: 10 }}
                loading={loading || undefined}
                onClick={() => {
                  navigator.clipboard.writeText(`https://www.integrador.app/assinante-aceitar-tce/${tce.id}/${assinante_escola.codigo}`);
                  toastify("Link copiado para a área de transferência");
                }}
              >
                Copiar link
              </Button>
            )}
          </div>
        </Assinante>
      );
    });
  }

  return (
    <>
      <Container>
        <h2>Aprovação dos assinantes da escola</h2>
        {renderAssinantes()}
      </Container>

      <Modal open={!!assinanteToRemove} onClose={() => setAssinanteToRemove(null)}>
        <ModalContent>
          <h2>Remover assinante</h2>
          <p>
            Deseja remover{" "}
            <strong>
              {assinanteToRemove?.assinante?.nome} {assinanteToRemove?.assinante?.sobrenome}
            </strong>{" "}
            como assinante deste TCE?
          </p>
          <ModalFooter>
            <Button
              block
              variant="magenta"
              loading={loading || undefined}
              onClick={() =>
                removeAssinante(assinanteToRemove.codigo, () => window.location.reload(false))
              }
            >
              Confirmar remoção
            </Button>
            <Button
              block
              variant="cancel"
              onClick={() => setAssinanteToRemove(null)}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
